import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'
import { EarlyAccessForm } from '@/components/EarlyAccessForm'

export function EarlyAccessCta() {
  const { t } = useTranslation()
  return (
    <section id="early-access" className="max-w-3xl mx-auto px-5 md:px-8 py-10 md:py-12">
      <ScrollFade as="h2" className="text-4xl md:text-5xl font-bold font-display text-center">
        {t('earlyAccess.heading')}
      </ScrollFade>
      <ScrollFade as="p" delay={120} className="mt-3 text-lg opacity-75 text-center max-w-xl mx-auto">
        {t('lorem:earlyAccess.blurb')}
      </ScrollFade>
      <ScrollFade as="div" delay={240} className="mt-8">
        <EarlyAccessForm />
      </ScrollFade>
    </section>
  )
}
